import React, { memo } from 'react';
import { getConfigKey } from '@utils/config-utils';
import './som-footer.scss';

const SomFooter = () => {
  const somConfig = getConfigKey('somDigitalStandards');
  if (!somConfig?.footer?.enabled) {
    return null;
  }

  const { footer } = somConfig;
  const year = new Date().getFullYear();

  return (
    <footer role="contentinfo" styleName="som-footer">
      <div styleName="som-footer-content">
        <div styleName="som-footer-links">
          {footer.links && footer.links.map(link => (
            <a
              key={link.label}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              styleName="som-footer-link"
            >
              {link.label}
            </a>
          ))}
        </div>
        <div styleName="som-footer-copyright">
          &copy; {year} {footer.copyright || 'State of Michigan'}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default memo(SomFooter);
